import { FeatureToggleClientService } from 'feature-toggle-client';
export const mergeTunnelContactDeskState = 'builder-merge-tunnel-contact-desk-state';
export const localDebugHosting = 'builder-local-debug-hosting';
export const undoRedoGlobal = 'undo-redo-global';
export const undoRedoContent = 'undo-redo-content';
export const undoRedoInput = 'undo-redo-input';
export const undoRedoAction = 'undo-redo-actions';
export const undoRedoOutputs = 'undo-redo-outputs';
export const undoRedoBlockTag = 'undo-redo-block-tag';
export const undoRedoBlockName = 'undo-redo-block-name';
export const undoRedoBlockPosition = 'undo-redo-block-position';
export const waitUserInput = 'wait-user-input';
export const useBuilderApplication = 'use-builder-application';
export const undoRedoAddRemoveMultipleBlocks = 'undo-redo-add-remove-multiple-blocks';
export const editMessageMetadata = 'edit-message-metadata';
export const attendanceRulesBuilder = 'attendance-rules-in-builder';
export const smartSalesBuilder = 'smart-sales-in-builder';
export const engineTimezone = 'engine-localtimezone-enabled';
export const autoClosingOfTicketsByCustomerInactivity = 'auto-closing-of-tickets-by-customer-inactivity';
export const isForwardToDeskAttendanceBoxEnabled = 'builder-new-desk-state-box-enabled';
export const redirectNoAgentsAvailable = 'builder-redirect-no-agents-available';
export const redirectOutOfAttendanceHour = 'builder-redirect-out-of-attendance-hour';
export const contactTaxDocument = 'contact-tax-document';
export const displayUpgradeDeskVersion = 'display-upgrade-desk-version';
export const outputVariable = 'builder-output-variable-state';
export const isMovingEnteringLeavingActionEnabled = 'is-moving-entering-leaving-action-enabled';
export const trackContactsJourney = 'track-contacts-journey';
export const testBucketFlow = 'builder-test-bucket-flow';
export const isIdentityHostingFallback = 'is-identity-hostring-fallback';
export const isMasterOfflineFeature = 'is-master-offline-feature';
export const hasPermissionToAccessSubflow = 'hasPermissionToAccessSubflow';
export const createBlocksWithCopilot = 'builder-create-blocks-with-copilot';
export const hasPermissionToAccessRelease2OfSubflow = 'hasPermissionToAccessRelease2OfSubflow';
export const isBuilderImprovedCopyPasteFeatureEnabled = 'is-builder-improved-copy-paste-feature-enabled';
export const hasPermissionToAccessPreparedBlocks = 'has-permission-to-access-prepared-blocks';
export const addOutputConditionsOnContentChange = 'builder-add-output-conditions-on-content-change';
export const builderDeskGoToSurvey = 'builder-desk-survey';
export const builderPreparedBlockDeskSurvey = 'builder-prepared-block-desk-survey';
export const isBuilderStickerDisabled = 'is-builder-sticker-disabled';
export const aiAnswers = 'ai-answers';
export const showBuilderChannelsExclusiveComponents = 'show-builder-channels-exclusive-components';
export const showWidgetBlipChatHelpCenterBuilder = 'widget-blip-chat-help-center-builder';
export const configurationsApplicationsDomainUsageGet = 'use-configurations-domain-on-misc-operations-get';
export const configurationsApplicationsDomainUsageSet = 'use-configurations-domain-on-misc-operations-set';
export const shouldAvoidDuplicateRouterService = 'should-avoid-duplicate-router-service';
export const isAiAgentCreateBuilderBlockEnabled = 'ai-agent-create-builder-block-enabled';
export const isEnabledSendHistoricToBrain = 'studio-enabled-send-historic-to-brain';
export const blipIdPreparedBlocksEnabled = 'blip-id-prepared-blocks-enabled';
export const aiAgentInterpretationsEnabled = 'ai-agent-interpretations-enabled';
export const studioPlanCheckingEnabled = 'studio-plan-checking-enabled';
export const studioPaymentBlockEnabled = 'studio-payment-block-enabled';
export const studioAiInput = 'studio-ai-agent-configuration-inputs';
export const studioInactivityHandoffEnabled = 'studio-inactivity-handoff-enabled';
export const agentSchemaEditorEnabled = 'agent-schema-editor-enabled';
export const studioGroundingToolsEnabled = 'studio-grounding-tools-enabled';
export const isLlmModelsAgentEnabled = 'new-llm-models-agent-block';
export const aiAgentSharedMemoryManipulation = 'ai-agent-shared-memory-manipulation';
export const studioVersioningEnabled = 'studio-versioning-enabled';
export const studioGroundingToolsMigrationEnabled = 'studio-grounding-tools-migration-enabled';
export const enableStudioPromptOptimizationFlag = 'studio-ai-agent-enable-prompt-optimization';
export class BuilderFeatures {
    static aiAnswersEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(aiAnswers);
    }
    static interpretationsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(aiAgentInterpretationsEnabled);
    }
    static aiInputEnabled(inputs, key) {
        return inputs[key] === true;
    }
    static async aiInputsByCluster(cluster = 'take') {
        const inputsEnabled = await FeatureToggleClientService.getInstance().isUserFeatureEnabled(studioAiInput);
        return inputsEnabled[cluster] ?? inputsEnabled['default'] ?? {};
    }
    static builderLocalDebugHosting() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(localDebugHosting);
    }
    static testBucketFlow() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(testBucketFlow);
    }
    static builderUndoRedoContentEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(undoRedoContent);
    }
    static outputVariableEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(outputVariable);
    }
    static builderLocalTimeZoneEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(engineTimezone);
    }
    static builderUndoRedoActionEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(undoRedoAction);
    }
    static builderUndoRedoOutputsEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(undoRedoOutputs);
    }
    static builderUndoRedoBlockTagEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(undoRedoBlockTag);
    }
    static builderUndoRedoBlockNameEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(undoRedoBlockName);
    }
    static builderUndoRedoBlockPositionEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(undoRedoBlockPosition);
    }
    static builderUndoRedoAddRemoveMultipleBlocksEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(undoRedoAddRemoveMultipleBlocks);
    }
    static builderWaitUserInputEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(waitUserInput);
    }
    static builderMergeTunnelContactDeskStateEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(mergeTunnelContactDeskState);
    }
    static useBuilderApplicationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(useBuilderApplication);
    }
    static editMessageMetadataEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(editMessageMetadata);
    }
    static attendanceRulesBuilderEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(attendanceRulesBuilder);
    }
    static smartSalesBuilderEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(smartSalesBuilder);
    }
    static isForwardToDeskAttendanceBoxEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isForwardToDeskAttendanceBoxEnabled);
    }
    static isRedirectNoAgentsAvailableEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(redirectNoAgentsAvailable);
    }
    static isRedirectOutOfAttendanceHourEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(redirectOutOfAttendanceHour);
    }
    static async isContactTaxDocumentEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(contactTaxDocument);
    }
    static displayUpgradeDeskVersion() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(displayUpgradeDeskVersion);
    }
    static movingEnteringLeavingActionEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isMovingEnteringLeavingActionEnabled);
    }
    static isTrackContactsJourneyEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(trackContactsJourney);
    }
    static isIdentityHostingFallback() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isIdentityHostingFallback);
    }
    static isMasterOfflineFeature() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isMasterOfflineFeature);
    }
    static shouldAvoidDuplicateRouterServiceEnable() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(shouldAvoidDuplicateRouterService);
    }
    static hasPermissionToAccessSubflowEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(hasPermissionToAccessSubflow);
    }
    static hasPermissionToCreateBlocksWithCopilotEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(createBlocksWithCopilot);
    }
    static hasPermissionToAccessRelease2OfSubflowEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(hasPermissionToAccessRelease2OfSubflow);
    }
    static isBuilderImprovedCopyPasteFeatureEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isBuilderImprovedCopyPasteFeatureEnabled);
    }
    static isBuilderPreparedBlocksEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(hasPermissionToAccessPreparedBlocks, false);
    }
    static builderAddOutputConditionsOnContentChange() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(addOutputConditionsOnContentChange);
    }
    static builderDeskGoToSurveyEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(builderDeskGoToSurvey, false);
    }
    static isBuilderPreparedBlockDeskSurveyEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(builderPreparedBlockDeskSurvey, false);
    }
    static isBuilderStickerDisabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isBuilderStickerDisabled, true);
    }
    static showBuilderChannelsExclusiveComponents() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(showBuilderChannelsExclusiveComponents);
    }
    static builderWidgetBlipChatHelpCenterEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(showWidgetBlipChatHelpCenterBuilder, false);
    }
    static isUseConfigurationsDomainOnMiscOperationsGetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(configurationsApplicationsDomainUsageGet, false);
    }
    static isUseConfigurationsDomainOnMiscOperationsSetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(configurationsApplicationsDomainUsageSet, false);
    }
    static isAiAgentCreateBuilderBlockEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isAiAgentCreateBuilderBlockEnabled, false);
    }
    static isEnabledSendHistoricToBrain() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isEnabledSendHistoricToBrain, false);
    }
    static blipIdPreparedBlocksEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(blipIdPreparedBlocksEnabled, false);
    }
    static isStudioCheckingEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(studioPlanCheckingEnabled, false);
    }
    static isStudioPaymentBlockEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(studioPaymentBlockEnabled, false);
    }
    static isStudioInactivityHandoffEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(studioInactivityHandoffEnabled, false);
    }
    static isStudioVersioningEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(studioVersioningEnabled, false);
    }
    static schemaEditorEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(agentSchemaEditorEnabled, false);
    }
    static isStudioGroundingToolsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(studioGroundingToolsEnabled, false);
    }
    static async isNewAiAgentLlmModelsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(isLlmModelsAgentEnabled, false);
    }
    /**
     * Check if AI Agent shared memory manipulation feature is enabled.
     *
     * Controls:
     * - History Config Sidebar (configure length/order per history variable)
     * - History Variable Sidebar (select variables with state control)
     * - "Manipulate history" button in prompt input
     * - PromptId preservation during reprocessing
     * - TargetPromptId validation for specific block editing
     *
     * @returns Promise<boolean> True if the feature is enabled for the user
     * @default false
     */
    static isAiAgentSharedMemoryManipulationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(aiAgentSharedMemoryManipulation, false);
    }
    /**
     * Check if Studio Grounding Tools Migration feature is enabled.
     *
     * This feature controls the migration process of grounding tools in the studio.
     * @returns
     * @default false
     */
    static isStudioGroundingToolsMigrationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(studioGroundingToolsMigrationEnabled, false);
    }
    static isStudioPromptOptimizationEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(enableStudioPromptOptimizationFlag, false);
    }
}
BuilderFeatures.builderUndoRedoInputEnabled = () => FeatureToggleClientService.getInstance().isUserFeatureEnabled(undoRedoInput);
